import { Pipe, PipeTransform } from '@angular/core';

import * as dayjs from 'dayjs';

@Pipe({ name: 'fileName' })
export class FileNamePipe implements PipeTransform {
  transform(fileName: string, part: 'name' | 'date' | 'time') {
    if (!fileName) return fileName;

    const splitFileName = fileName.split('_');

    switch (part) {
      case 'name':
        if (splitFileName[0].includes('enhanced')) {
          return `Mastered: ${this.prettyName(splitFileName[1])}`;
        } else if (splitFileName[0].includes('mix')) {
          return `Mix: ${this.prettyName(splitFileName[1])}`;
        } else {
          return this.prettyName(splitFileName[0]);
        }

      case 'date':
        if (splitFileName[0].includes('enhanced')) {
          return dayjs(splitFileName[3], 'MM-D-YYYY').format('M/D/YY');
        } else {
          return dayjs(splitFileName[2], 'MM-D-YYYY').format('M/D/YY');
        }

      case 'time':
        if (splitFileName[0].includes('enhanced')) {
          return dayjs(splitFileName[4], 'HHmmss').format('h:mm a');
        } else {
          return dayjs(splitFileName[3], 'HHmmss').format('h:mm a');
        }

      default:
        return splitFileName[0];
    }
  }

  prettyName(fileName: string) {
    return fileName
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
